import React, { Suspense } from "react";
import { useLocation } from "react-router-dom";

import ErrorBoundary from "../ErrorBoundries";
import { AppWrapper, ContentWrapper } from "../LayoutWrappers";
import { Stack, useTheme } from "@mui/material";
import useNavigationProps from "src/layout/Navigation/NavigationBar.hook";
import { useIsMobile, useCurrentFullAccountPage } from "@hooks";
import NavigationBar from "../Navigation/NavigationBar";
import OutletWithErrorHandling from "../OutletWithErrorHandling";
import { ALL_ASSISTANTS } from "@consts";
import { NAVIGATION_MODES } from "src/layout/Navigation/NavigationBar.consts";
import AccountHeader from "../Content/AccountHeader";

const AccountLayout = () => {
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useIsMobile();
  const navigationProps = useNavigationProps(NAVIGATION_MODES.ACCOUNT);
  const hasOnlyOneItemInNavigation = navigationProps?.sections?.[0]?.items?.length === 1;
  const page = useCurrentFullAccountPage();
  const isAllAgentsPage = page === ALL_ASSISTANTS;
  const customLayout = isAllAgentsPage ? {
    maxWidth: 1640,
    margin: "0 auto",
    [`@media (max-width: ${theme.breakpoints.desktop - 1}px)`]: {
      maxWidth: 1200,
      margin: "0 auto"
    }
  } : null;

  return (
    <Stack direction="row">
      {!isMobile && !hasOnlyOneItemInNavigation && (
        <NavigationBar
          {...navigationProps}
          useCurrentPage={useCurrentFullAccountPage}
        />
      )}
      <Suspense>
        <AppWrapper className="app" sx={{ backgroundColor: theme => theme.palette.grey[50] }} statusBarDisplayed={navigationProps.showStatusBar}>
          <ContentWrapper component="main" overrideLayout={customLayout}>
            <ErrorBoundary key={location.pathname}>
              <AccountHeader {...navigationProps} />
              <OutletWithErrorHandling />
            </ErrorBoundary>
          </ContentWrapper>
        </AppWrapper>
      </Suspense>
    </Stack>
  );
};

export default AccountLayout;
